import React from 'react';

export default function DefaultMagnifierContainer({className, children, ...props}) {
	className = "magnifier-cnt"+(className?" "+className:"");
	return <div className={className} {...props}>
		{children}
	</div>
}
